module.exports = __webpack_public_path__ + "img/undraw_palette_110c.f0661b96.svg";